export default __webpack_public_path__ + "static/media/avatar-3.57028529.png";